import { Box, Button, Text, Flex, Alert, AlertIcon } from '@chakra-ui/react'
import { MdOutlineSwapHoriz } from 'react-icons/md'

export function SubmitButton({ onSubmit, isSubmitting, isDisabled, allPhotosTaken, selectedProduto, observacao, quantidade }) {
  const getReason = () => {
    if (!selectedProduto) return 'Selecione um produto para troca'
    if (!allPhotosTaken()) return 'Tire as 3 fotos do produto'
    if (!observacao.trim()) return 'Adicione uma observação sobre o motivo da troca'
    if (!quantidade || quantidade <= 0) return 'Informe uma quantidade válida'
    return ''
  }

  return (
    <Box mb={6} p={6} shadow="md" borderWidth="1px" borderRadius="lg" bg="#3a4a53" color="white">
      {isDisabled && (
        <Alert status="warning" mb={4} borderRadius="md" bg="#4a5a64">
          <AlertIcon />
          {getReason()}
        </Alert>
      )}

      <Button
        leftIcon={<MdOutlineSwapHoriz size={24} />}
        bgColor="#37F091"
        color="#313E44"
        size="lg"
        w="full"
        h="60px"
        fontSize="lg"
        onClick={onSubmit}
        isLoading={isSubmitting}
        loadingText="Enviando solicitação..."
        isDisabled={isDisabled}
        _hover={{ bg: '#2cdf7f' }}
        _disabled={{ opacity: 0.6, cursor: 'not-allowed' }}
      >
        Solicitar Troca
      </Button>

      <Text fontSize="sm" color="gray.300" mt={3} textAlign="center">
        Ao solicitar a troca, suas fotos serão enviadas para análise.
      </Text>

      <Flex justify="center" mt={2}>
        <Text fontSize="xs" color="gray.400">
          Certifique-se de que as fotos mostram claramente o problema do produto.
        </Text>
      </Flex>
    </Box>
  )
}
